module.exports = __webpack_public_path__ + "static/media/show-gal-2.dc397135.jpg";